import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components';

export const AboutPage: React.FC = () => {
  const { t } = useTranslation('pages');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-[#0B1F3A]">{t('about.title')}</h1>
        <p className="mt-4 text-xl text-gray-700 font-semibold">
          {t('about.subtitle')}
        </p>
      </div>

      <div className="space-y-6 text-gray-700">
        <p className="text-lg">{t('about.description1')}</p>
        <p className="text-lg">{t('about.description2')}</p>
        <p className="text-lg font-semibold">{t('about.emphasis')}</p>

        <section className="text-center py-8">
          <p className="text-lg font-semibold text-gray-800 mb-4">
            {t('about.curious')}
          </p>
          <Link to="/werkwijze">
            <Button size="lg" variant="primary">
              {t('about.seeApproach')}
            </Button>
          </Link>
        </section>
      </div>
    </div>
  );
};
